export enum ProactiveType {
    PAGE_VIEW,
    DELAY,
    CUSTOM_EVENT,
    SCROLL_DEPTH,
    EXIT_INTENT,
    PAGE_VIEW_COUNT,
}